export default "__VITE_ASSET__BWsg4HU3__"